import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewChild } from '@angular/core';
import { ColumnDefinition, TabulatorFull as Tabulator } from 'tabulator-tables';

@Component({
	selector: 'app-tabulator-table',
	template: `
		<!-- <button style="position:absolute; transform:translateY(-200%)" mat-raised-button (click)="printDialog()">הדפס</button> -->
		<div #tableContainer></div>
	`,
})
export class TabulatorTableComponent implements OnChanges, OnDestroy {
	@Input() tableData: any[] = [];
	@Input() columnNames: ColumnDefinition[] = [];
	@Input() height: string;
	@Input() rowToScrollTo: number;

	@Output() readonly rowClick = new EventEmitter<typeof this.tableData[number]>();
	@Output() readonly scrolledToRow = new EventEmitter<void>();

	tab = document.createElement('div');
	tabulator: Tabulator;

	@ViewChild('tableContainer') tableContainer: ElementRef<HTMLDivElement>;

	constructor() {}

	ngOnDestroy(): void {
		this.tabulator?.off('renderComplete');
		this.tabulator?.off('rowClick');
	}

	ngOnChanges(): void {
		if (!this.tableContainer?.nativeElement) return;
		this.drawTable();
	}

	private drawTable(): void {
		this.tabulator = new Tabulator(this.tab, {
			data: this.tableData,
			columns: this.columnNames,
			layout: 'fitColumns',
			height: this.height || '50vh',
			// locale: 'true',
			printAsHtml: true,
			movableColumns: true,
			resizableColumnFit: true,
			printStyled: true,
			scrollToRowIfVisible: false,
		});
		this.tabulator.on('renderComplete', () => {
			if (!this.rowToScrollTo || !this.tableData?.length) return;

			const rows = this.tabulator.getRows();
			const row = rows[this.rowToScrollTo - 1];
			if (!row) {
				console.error(`Scroll Error - No matching row found: ${this.rowToScrollTo}`);
				return;
			}

			this.tabulator.scrollToRow(row, 'top', true);
		});

		this.tabulator.on('rowClick', (e, row) => {
			this.rowClick.emit({ ...row.getData(), rowToScrollTo: row.getPosition(true) });
		});
		this.tableContainer.nativeElement.appendChild(this.tab);
	}

	printDialog() {
		this.tabulator.print();
	}
}
